import { Component, Inject } from '@angular/core';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageEnum } from 'src/app/models/enums/local-storage.enum';
import { LoadingService } from 'src/app/services/loading.service';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { DOCUMENT } from '@angular/common';
import { GoogleMapService } from 'src/app/services/google-map.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  isLoading = false;
  loadingTimeout!: ReturnType<typeof setTimeout>;
  browserLang!: string;

  constructor(
    private router: Router,
    public loadingService: LoadingService,
    private translate: TranslateService,
    private localStorageService: LocalStorageService,
    private _googleMapService: GoogleMapService,
    @Inject(DOCUMENT) private _document: Document
  ) {
    this._loadGoogleMapSdk();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.loadingService.forceStop();
        this.loadingService.setLoading('page', true);

        //prevent loading for the same url of post and get
        setTimeout(() => {
          this.loadingService.url = '';
          this.loadingService.setLoading('page', false);
        }, 0);
      } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
        this.loadingService.setLoading('page', false);
        this.loadingService.url = '';
      }
    });

    translate.addLangs(['en', 'km']);
    translate.setDefaultLang('km');

    this.browserLang = localStorageService.get(LocalStorageEnum.language); //navigator.language;
    translate.use(this.browserLang.match(/en|zh-CN|km/) ? this.browserLang : 'km'); // default language 'km'
  }

  private _loadGoogleMapSdk() {
    var script = this._document.createElement('script');
    script.src = 'https://maps.googleapis.com/maps/api/js?key=' + environment.GOOGLE_MAP_API_KEY + "&loading=async&callback=initMap";
    script.async = true;

    // Attach your callback function to the `window` object
    // @ts-ignore
    window.initMap = () => {
      this._googleMapService.loaded = true;
    }

    // Append the 'script' element to 'head'
    this._document.head.appendChild(script);
  }
}
